import { render, staticRenderFns } from "./UploadLogo.vue?vue&type=template&id=66c2563e&scoped=true"
import script from "./UploadLogo.vue?vue&type=script&lang=ts"
export * from "./UploadLogo.vue?vue&type=script&lang=ts"
import style0 from "./UploadLogo.vue?vue&type=style&index=0&id=66c2563e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2563e",
  null
  
)

export default component.exports